// removed by extract-text-webpack-plugin
module.exports = {"videoList":"nrk-du-saa-meg-videoList","videoheader":"nrk-du-saa-meg-videoheader"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/VideoList/videoList.css
// module id = 260
// module chunks = 1